module.exports = __webpack_public_path__ + "img/xml-img.009a26dd.png";